module.exports = __webpack_public_path__ + "img/BFSE.759eff4c.png";